import Model from "../Model";

export default class Target extends Model {
  static type = "grpTargets";

  name!: string;
  columns!: Array<string>;
  tags!: Array<string[]>;

  get isCustom(): boolean {
    return this.tags.join(" ").includes("custom");
  }
}
